export default {
    Analytics: {
        Feedback: {
            actions: {
                nextPane: "NextPane",
                completePane: "Pane Completed",
                completeFeedback: "Feedback Completed",
                abortPane: "Pane Aborted",
                abortFeedback: "Feedback Aborted",
            },
            category: "Feedback",
            freeformTextQuery: null,
            labels: {
                okPane: "OK",
                transitionPane: "Transition",
                yesButton: "Yes Button",
                noButton: "No Button",
                dataCollection: "Data Collection",
            },
            selectedOptionQuery: null,
        },
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/analytics.ts